<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-alert v-if="failedLogin" variant="danger" show><i class="fa fa-times"></i> Your email or password is incorrect.</b-alert>
                <b-form class="login" @submit.prevent="login">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" v-model="email" name="email" class="form-control" placeholder="Email" autocomplete="email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="password" name="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" name="submit" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <router-link class="btn px-0 btn-link" to="forgot-password">
                        Forgot password?
                      </router-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      failedLogin: false
    }
  },
  methods: {
    /**
     * Dispatches a login auth request to the vuex store with the email and password in order to login and redirect admin to dashboard if login successful.
     */
    login: function () {
      const { email, password } = this

      this.$store.dispatch('AUTH_REQUEST', { email, password }).then((response) => {
        this.$router.push('/')
      }).catch((err) => {
        if (err) {
          this.failedLogin = true
        }
      })
    }
  }
}
</script>
